import { useEffect, useState, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Footer from "../standartComponents/footer";
import Header from "../standartComponents/header";
import AboutBlock from "./aboutBlock";
import FirstBlock from "./firstBlock";
import NewFirstBlock from './NewFirstBlock';
import BottomBlock from "./bottomBlock";
import css from "./main.module.css";
import PopularVideo from "../catalog/popularVideo";
import AllTems from "./allTems";
import { getVideoCategories } from "../../lib/videoCategoryApi";
import { getVideoLessons } from "../../lib/videoLessonApi";
import Loader from "../standartComponents/loader";
import { getLanguageLevels } from "../../lib/getLanguageLevels";
import { IoSearchOutline } from "react-icons/io5";
import { useTranslation } from "react-i18next";
import i18n from "../../i18n";
import Swal from "sweetalert2";
import UserAccount from "../catalog/userAccount";
import NavigationTabs from "../catalog/navigationTabs";
import AllVideosView from "../catalog/AllVideosView";
import AccountHeader from "../standartComponents/AccountHeader";
import Policies from "../standartComponents/policies";

const levelNumberMap = {
  A1: 1,
  A2: 2,
  B1: 3,
  B2: 4,
  C1: 5,
  C2: 6,
};

const MainPage = ({ authUser }) => {
  const [categories, setCategories] = useState([]);
  const [lessonsByCategory, setLessonsByCategory] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [selectedLevel, setSelectedLevel] = useState(null);
  const [allLevels, setAllLevels] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchValue, setSearchValue] = useState("");
  const [showUserAccount, setShowUserAccount] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [activeTab, setActiveTab] = useState('my learning');
  const location = useLocation();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const popupIntervalRef = useRef(null);
  const popupTimeoutRef = useRef(null);

  const [showHero, setShowHero] = useState(true);

  console.log(authUser)

  {/*  useEffect(() => {
    const stored = localStorage.getItem("selectedPurpose");
  
    if (!stored) {
      // No purpose saved → show all videos
      setSelectedCategories([]);
      setSelectedLevel(null);
      setSearchTerm("");
      setSearchValue("");
      //localStorage.removeItem("selectedLevel");
      localStorage.setItem("selectedPurpose", JSON.stringify({ categories: [] }));
      //fetchLessons([], null);
    } else {
      const level = localStorage.getItem("selectedLevel");
      console.log("Level from localStorage:", level);
      
      // Don't convert to Number, use the level value directly
      const levelKey = level;
      sessionStorage.setItem("restoreScroll", "true");
      sessionStorage.setItem("scrollY", window.scrollY);
    
      setSelectedLevel(levelKey);
      // Only convert to number when using as an index in levelNumberMap
     // localStorage.setItem("selectedLevel", level);
    
      //fetchLessons(selectedCategories, levelKey);
    }
  }, []);


  // Scroll animation effect with bottom block illusion
  useEffect(() => {
    let ticking = false;
    let bottomBlockStartY = null;
    let lastTransform = 0;
    let isIllusionActive = false;

    const updateScrollProgress = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const heroHeight = window.innerHeight;
      const scrollRatio = Math.min(scrollTop / (heroHeight * 0.6), 1);

      const hero = document.querySelector('[class*="hero"]');
      const videoDiscovery = document.querySelector('[class*="videoDiscoverySection"]');
      const bottomBlock = document.querySelector('[class*="benefits"]');

      // Hero fade animation
      if (hero && videoDiscovery) {
        if (scrollRatio > 0) {
          // Fade out hero and move content up slightly
          hero.style.opacity = 1 - scrollRatio;
          hero.style.transform = `translateY(${scrollRatio * -50}px)`;

          // Reveal video discovery section
          videoDiscovery.classList.add(css.reveal);
        } else {
          // Reset hero when at top
          hero.style.opacity = 1;
          hero.style.transform = 'translateY(0)';
          videoDiscovery.classList.remove(css.reveal);
        }
      }

      // Bottom block illusion effect with smoothing
      if (bottomBlock && videoDiscovery) {
        // Calculate when bottom block comes into view
        const bottomBlockRect = bottomBlock.getBoundingClientRect();
        const windowHeight = window.innerHeight;

        // When bottom block starts entering the viewport
        if (bottomBlockRect.top <= windowHeight && bottomBlockRect.bottom > 0) {
          // Store the scroll position when bottom block first appears
          if (bottomBlockStartY === null) {
            bottomBlockStartY = scrollTop - (windowHeight - bottomBlockRect.top);
            isIllusionActive = true;
          }

          // Calculate how much user has scrolled since bottom block appeared
          const scrolledSinceBottomBlock = scrollTop - bottomBlockStartY;

          // Smooth the transform value to reduce shaking
          const smoothedTransform = Math.round(scrolledSinceBottomBlock);

          // Only apply transform if the change is significant enough (reduces micro-movements)
          if (Math.abs(smoothedTransform - lastTransform) >= 5) {
            videoDiscovery.style.transform = `translateY(${smoothedTransform}px)`;
            videoDiscovery.style.transition = 'none';
            videoDiscovery.style.willChange = 'transform'; // Optimize for transforms
            lastTransform = smoothedTransform;
          }
        } else {
          // Reset when bottom block is not in view
          if (isIllusionActive) {
            bottomBlockStartY = null;
            isIllusionActive = false;
            lastTransform = 0;
            videoDiscovery.style.transform = '';
            videoDiscovery.style.transition = '';
            videoDiscovery.style.willChange = 'auto';
          }
        }
      }

      ticking = false;
    };

    const requestTick = () => {
      if (!ticking) {
        requestAnimationFrame(updateScrollProgress);
        ticking = true;
      }
    };

    window.addEventListener('scroll', requestTick, { passive: true });

    // Initial check
    updateScrollProgress();

    return () => {
      window.removeEventListener('scroll', requestTick);
    };
  }, [css.hero, css.videoDiscoverySection, css.reveal]);*/}


  const getAllChildCategories = (parentId, allCats) => {
    const children = allCats.filter((cat) => cat.parent === parentId);
    let allIds = children.map((cat) => cat.id);
    children.forEach((child) => {
      allIds = [...allIds, ...getAllChildCategories(child.id, allCats)];
    });
    return allIds;
  };

  const handleNavigate = (path, options = {}) => {
    navigate(path, options);
  };

  useEffect(() => {
    if (selectedLevel !== null && categories.length > 0) {
      fetchLessons(selectedCategories, selectedLevel);
      console.log('cat:', selectedCategories)
      console.log('lev:', selectedLevel)
    }
  }, [selectedLevel, selectedCategories]);

  const fetchLessons = async (categoriesToFetch, levelKey) => {
    setIsLoading(true);

    try {
      // Handle level key properly - if it's a comma-separated string, split it
      let levelsToFetch = [];
      if (levelKey) {
        if (typeof levelKey === 'string' && levelKey.includes(',')) {
          // It's a group selection like "1,2"
          levelsToFetch = levelKey.split(',').map(Number);
        } else {
          // It's a single level
          levelsToFetch = [typeof levelKey === 'number' ? levelKey : parseInt(levelKey)];
        }
      }

      const lessonRes = await getVideoLessons({
        categories: categoriesToFetch,
        levels: levelsToFetch.length > 0 ? levelsToFetch : [],
      });

      const grouped = {};
      lessonRes.results.forEach((lesson) => {
        const id = lesson.video.category;
        if (!grouped[id]) grouped[id] = [];
        grouped[id].push(lesson);
      });

      setLessonsByCategory(grouped);
    } catch (err) {
      console.error("❌ Помилка при завантаженні уроків:", err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleCategoryClick = (categoryId) => {
    // store scroll position before reload
    sessionStorage.setItem("restoreScroll", "true");
    sessionStorage.setItem("scrollY", window.scrollY);

    const children = getAllChildCategories(categoryId, categories);
    const fullList = [categoryId, ...children];

    setSelectedCategories((prev) => {
      const alreadySelected = prev.includes(categoryId);
      const updated = alreadySelected
        ? prev.filter((id) => !fullList.includes(id))
        : [...new Set([...prev, ...fullList])];

      const stored = localStorage.getItem("selectedPurpose");
      let parsed = {};
      if (stored) {
        try {
          parsed = JSON.parse(stored);
        } catch {
          parsed = {};
        }
      }
      parsed.categories = updated;
      localStorage.setItem("selectedPurpose", JSON.stringify(parsed));

      fetchLessons(updated, selectedLevel);
      return updated;
    });

    // Switch to all videos tab when category is clicked
    setActiveTab('all videos');
  };

  useEffect(() => {
    if (!isLoading) {
      const shouldRestore = sessionStorage.getItem("restoreScroll") === "true";
      if (shouldRestore) {
        const y = Number(sessionStorage.getItem("scrollY")) || 0;
        window.scrollTo(0, y);

        // reset so it doesn’t persist on normal reloads
        sessionStorage.removeItem("restoreScroll");
        sessionStorage.removeItem("scrollY");
      } else {
        window.scrollTo(0, 0); // normal refresh → first section
      }
    }
  }, [isLoading]);

  const handleLevelFilter = (levelKey) => {
    // 🔹 Save scroll position before reload
    sessionStorage.setItem("restoreScroll", "true");
    sessionStorage.setItem("scrollY", window.scrollY);

    setSelectedLevel(levelKey);
    // Store the levelKey directly, not the numeric ID
    if (levelKey) {
      localStorage.setItem("selectedLevel", levelKey);
    } else {
      localStorage.removeItem("selectedLevel");
    }
    console.log(levelKey);

    fetchLessons(selectedCategories, levelKey);

    // Switch to all videos tab when level is selected
    setActiveTab('all videos');
  };

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchValue(value);
    setSearchTerm(value);
    // No fetching - we'll filter on frontend
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    // Search is already handled by onChange, no need to do anything here
  };

  const handleClearAllFilters = () => {
    sessionStorage.setItem("restoreScroll", "true");
    sessionStorage.setItem("scrollY", window.scrollY);

    setSelectedCategories([]);
    setSelectedLevel(null);
    setSearchTerm("");
    setSearchValue("");
    localStorage.removeItem("selectedLevel");
    localStorage.setItem("selectedPurpose", JSON.stringify({ categories: [] }));
    fetchLessons([], null);
  };

  useEffect(() => {
    const fetchInitial = async () => {
      try {
        const catRes = await getVideoCategories();
        const levelIn = await getLanguageLevels();
        const allCategories = catRes.results;
        setCategories(allCategories);

        const validCategoryIds = allCategories.map((cat) => cat.id);
        const stored = localStorage.getItem("selectedPurpose");

        let expanded = [];
        let levelKey = null;

        if (levelIn) {
          setAllLevels(levelIn.results);
        }

        if (stored) {
          try {
            const parsed = JSON.parse(stored);

            if (Array.isArray(parsed.categories)) {
              const filtered = parsed.categories.filter((id) =>
                validCategoryIds.includes(id)
              );
              const expandedSet = filtered.flatMap((id) => [
                id,
                ...getAllChildCategories(id, allCategories),
              ]);
              expanded = [...new Set(expandedSet)];
              setSelectedCategories(expanded);
            }

            if (parsed.level && levelNumberMap[parsed.level]) {
              levelKey = parsed.level;
              setSelectedLevel(levelKey);
            }
          } catch (e) {
            console.warn("❌ Не вдалося прочитати selectedPurpose", e);
          }
        }

        const storedLevelId = localStorage.getItem("selectedLevel");
        if (storedLevelId) {
          // Handle both single numbers and comma-separated strings
          if (storedLevelId.includes(',')) {
            // It's a group selection like "1,2"
            setSelectedLevel(storedLevelId);
            levelKey = storedLevelId;
          } else {
            // It's a single level - could be a number or A1/A2/B1/B2 format
            const numericLevel = parseInt(storedLevelId);
            if (!isNaN(numericLevel)) {
              // It's a numeric level like "2"
              setSelectedLevel(numericLevel);
              levelKey = numericLevel;
            } else if (Object.keys(levelNumberMap).includes(storedLevelId)) {
              // It's in A1/A2/B1/B2 format
              setSelectedLevel(storedLevelId);
              levelKey = storedLevelId;
            }
          }
        }

        await fetchLessons(expanded, levelKey);
      } catch (err) {
        console.error("❌ Помилка при ініціалізації:", err);
        setIsLoading(false);
      }
    };

    fetchInitial();
  }, [location.pathname]);

  /*const showPopup = () => {
    Swal.fire({
      title: t("popupTitle", "Бажаєте розпочати навчання?"),
      confirmButtonText: t("startLearning", "Розпочати"),
      allowOutsideClick: true,
      allowEscapeKey: true,
      confirmButtonColor: "#621eeb",
    }).then((result) => {
      if (result.isConfirmed) {
        clearInterval(popupIntervalRef.current);
        navigate("/language");
      }
    });
  };*/

  if (isLoading) {
    return (
      <div className={css.centrSpiner}>
        <Loader />
      </div>
    );
  }

  return (
    <div style={{
      width: "100%",
      height: "auto",
      overflowX: "hidden",

    }}>

    {authUser.isAuthenticated ? (
 <AccountHeader
        authUser={authUser}
        isAccount={true}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        setActiveMyVideosTab={() => { }}
        categories={categories}
        selectedCategoryIds={selectedCategories}
        onCategoryClick={handleCategoryClick}
        selectedLevel={selectedLevel}
        setSelectedLevel={setSelectedLevel}
        allLevels={allLevels}
        onLevelFilter={handleLevelFilter}
        onClearAllFilters={handleClearAllFilters} />
    ) : (
      <Header authUser={authUser} />
    )}
     
      {authUser.isAuthenticated && (
        <div style={{ display: "none" }}>
          <NavigationTabs
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            setActiveMyVideosTab={() => { }}
            categories={categories}
            selectedCategoryIds={selectedCategories}
            onCategoryClick={handleCategoryClick}
            selectedLevel={selectedLevel}
            setSelectedLevel={setSelectedLevel}
            allLevels={allLevels}
            onLevelFilter={handleLevelFilter}
            onClearAllFilters={handleClearAllFilters}
          /></div>
      )}
      {authUser.isAuthenticated ? (
        activeTab === 'my learning'
          ? <UserAccount
            authUser={authUser}
            categories={categories}
            selectedCategoryIds={selectedCategories}
            onCategoryClick={handleCategoryClick}
            onClearAllFilters={handleClearAllFilters}
            selectedLevel={selectedLevel}
            onLevelFilter={handleLevelFilter}
            allLevels={allLevels}
            setActiveTab={setActiveTab}
          />
          : <div className={css.allVidCon}> <AllVideosView 
            authUser={authUser}
            categories={categories}
            selectedCategories={selectedCategories}
            selectedLevel={selectedLevel}
            lessonsByCategory={lessonsByCategory}
            allLevels={allLevels}
          /></div>

      ) : (
        <NewFirstBlock authUser={authUser} />
      )}
      <Policies />
    </div>
  );
};

export default MainPage;
